import { all, fork } from "redux-saga/effects";

import watchAuthActions from "../pages/auth/store/auth.saga";
import watchNftActions from "../pages/nfts/store/nfts.saga";
import watchAdminActions from "../pages/admin/store/admin.saga";
import watchAdminEdmActions from "../pages/admin/edm/store/admin-edm.saga";

export function* rootSaga() {
    yield all([fork(watchAuthActions), fork(watchNftActions), fork(watchAdminActions), fork(watchAdminEdmActions)])
}
